import Login from '../pages/Login';
import Applicants from '../pages/Application';
import Register from '../pages/Register';
import Home from '../pages/Home';
import ApplicantDetail from '../pages/ApplicantDetail';
import JobListing from '../pages/JobListing';
import JobPostDetail from '../pages/JobPostDetail';
import JobPostingForm from '../pages/CreateJob';
import CompanyProfile from '../pages/CompanyProfile';
import PostsListing from '../pages/Posts';
import TeamMembers from '../pages/TeamMembers';
import HomeSwitcher from '../pages/HomeSwitcher';
import AdminJobListing from '../pages/AdminJobListing';
import AdminCompanyListing from '../pages/AdminCompanyListing';
import AdminUsersListing from '../pages/AdminUsersListing';
import UserProfileView from '../pages/UserProfileView';
import Notification from '../pages/Notifications';

// config/routes.js
export const ROLES = {
    ADMIN: 'admin',
    FUND_MANAGER: 'platform_company',
    CUSTOMER: 'platform_user'
  };

  export const routes = [
    {
      path: '/login',
      element: Login,
      protected: false,
      roles: [] // public route
    },
    {
      path: '/signup',
      element: Register,
      protected: false,
      roles: []
    },
    {
      path: '/',
      element: HomeSwitcher,
      protected: true,
      roles: [ROLES.FUND_MANAGER, ROLES.ADMIN]
    },
    {
      path: '/applications',
      element: Applicants,
      protected: true,
      roles: [ROLES.FUND_MANAGER]
    },
    {
      path: '/application-detail/:applicantId',
      element: ApplicantDetail,
      protected: true,
      roles: [ROLES.FUND_MANAGER]
    },
    {
      path: '/listing',
      element: JobListing,
      protected: true,
      roles: [ROLES.FUND_MANAGER]
    },
    {
      path: '/job-detail/:jobId',
      element: JobPostDetail,
      protected: true,
      roles: [ROLES.FUND_MANAGER, ROLES.ADMIN]
    },
    {
      path: '/create-job',
      element: JobPostingForm,
      protected: true,
      roles: [ROLES.FUND_MANAGER]
    },
    {
      path: '/company-profile',
      element: CompanyProfile,
      protected: true,
      roles: [ROLES.FUND_MANAGER]
    },
    {
      path: '/posts',
      element: PostsListing,
      protected: true,
      roles: [ROLES.FUND_MANAGER, ROLES.ADMIN]
    },
    {
      path: '/teams',
      element: TeamMembers,
      protected: true,
      roles: [ROLES.FUND_MANAGER]
    },
    {
      path: '/admin-listing',
      element: AdminJobListing,
      protected: true,
      roles: [ROLES.ADMIN]
    },
    {
      path: '/admin-company-listing',
      element: AdminCompanyListing,
      protected: true,
      roles: [ROLES.ADMIN]
    },
    {
      path: '/view-company-profile/:companyId',
      element: CompanyProfile,
      protected: true,
      roles: [ROLES.FUND_MANAGER, ROLES.ADMIN]
    },
    {
      path: '/list-users',
      element: AdminUsersListing,
      protected: true,
      roles: [ROLES.ADMIN]
    },
    {
      path: '/view-user-profile/:userId',
      element: UserProfileView,
      protected: true,
      roles: [ROLES.ADMIN]
    },
    {
      path: '/notifications',
      element: Notification,
      protected: true,
      roles: [ROLES.ADMIN, ROLES.FUND_MANAGER]
    },
    // {
    //   path: '/create-campaign',
    //   element: CreateCampaign,
    //   protected: true,
    //   roles: [ROLES.CUSTOMER, ROLES.ADMIN]
    // },
    // {
    //   path: '/edit-campaign/:campaignId',
    //   element: EditCampaign,
    //   protected: true,
    //   roles: [ROLES.CUSTOMER, ROLES.ADMIN]
    // },
    // {
    //   path: '/history',
    //   element: History,
    //   protected: true,
    //   roles: [ROLES.CUSTOMER, ROLES.ADMIN]
    // },
    // {
    //   path: '/image-create',
    //   element: ImageCreateRedirect,
    //   protected: true,
    //   roles: [ROLES.CUSTOMER, ROLES.ADMIN]
    // },
    // {
    //   path: '/image-create/:sessionId',
    //   element: ImageCreate, 
    //   protected: true,
    //   roles: [ROLES.CUSTOMER, ROLES.ADMIN]
    // },
    // {
    //   path: '/workflows',
    //   element: Workflow, 
    //   protected: true,
    //   roles: [ROLES.ADMIN]
    // },
    // {
    //   path: '/view-workflow/:id',
    //   element: ViewWorkflow, 
    //   protected: true,
    //   roles: [ROLES.ADMIN]
    // },
    // {
    //   path: '/create-workflow',
    //   element: CreateWorkflow, 
    //   protected: true,
    //   roles: [ROLES.ADMIN]
    // },
    // {
    //   path: '/analytics',
    //   element: Analytics, 
    //   protected: true,
    //   roles: [ROLES.ADMIN]
    // },
    // {
    //   path: '/profile',
    //   element: Profile,
    //   protected: true,
    //   roles: [ROLES.CUSTOMER, ROLES.ADMIN]
    // },
    // ... other routes with their respective role requirements
  ];
  